import { request } from '@/shared/api/request'

export const postXmlByExternalId = ({payload, params}) => {
	return request({ url: `assessment/xml/${payload.externalId}`, method: 'GET', params: params })
}

export const postXmlSend = (payload) => {
	return request({ url: 'assessment/send', method: 'POST', data: payload })
}